import type { AudioSourceData } from '@lumen5/luminary';

import type { AudioAssetModel, SlideBackgroundModel } from 'js/src/client';
import { SlideBackgroundModelTypeEnum } from 'js/src/client';
import type { PlayableAudio, VideoBackgroundModel } from 'js/src/data/media/media-types';
import type { DeepReadonly, ImmutableMap } from 'js/src/libs/consts';
import { ImmutableFromJS, toMutableCopy } from 'js/src/libs/consts';

export function toImmutableSlideBackground(
    background: DeepReadonly<SlideBackgroundModel>,
): ImmutableMap<SlideBackgroundModel> {
    return ImmutableFromJS(
        toMutableCopy<SlideBackgroundModel>(background),
    ) as ImmutableMap<SlideBackgroundModel>;
}

export function toImmutableAudioAsset(
    audio: DeepReadonly<AudioAssetModel>,
): ImmutableMap<AudioAssetModel>;
export function toImmutableAudioAsset(
    audio: PlayableAudio,
): ImmutableMap<AudioAssetModel | AudioSourceData>;
export function toImmutableAudioAsset(
    audio: PlayableAudio,
): ImmutableMap<AudioAssetModel | AudioSourceData> {
    return ImmutableFromJS(toMutableCopy<AudioAssetModel | AudioSourceData>(audio)) as ImmutableMap<
        AudioAssetModel | AudioSourceData
    >;
}

export type ImmutableAudioAsset = ImmutableMap<AudioAssetModel>;

export function isImmutableAudioAsset(media: unknown): media is ImmutableAudioAsset {
    return (media as ImmutableAudioAsset).get('mp3_url') !== undefined;
}

export function immutableSlideBackgroundModelIsImmutableVideoBackgroundModel(
    backgroundAsset: ImmutableMap<SlideBackgroundModel>,
): backgroundAsset is ImmutableMap<VideoBackgroundModel> {
    return backgroundAsset.get('type') === SlideBackgroundModelTypeEnum.VIDEO;
}
